import { stageOf, PRIORITY_CLS, ROLE_CLS, PAY_CLS } from "../lib/constants";

const base = "inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold capitalize whitespace-nowrap";

export const StageBadge = ({ status, testid }) => {
  const s = stageOf(status);
  return <span data-testid={testid} className={`${base} ${s.cls}`}>{s.label}</span>;
};
export const PriorityBadge = ({ p }) => <span className={`${base} ${PRIORITY_CLS[p] || PRIORITY_CLS.low}`}>{p}</span>;
export const RoleBadge = ({ role, testid }) => (
  <span data-testid={testid} className={`${base} ${ROLE_CLS[role]}`}>{role === "hr" ? "HR" : role}</span>
);
export const PayBadge = ({ s, testid }) => <span data-testid={testid} className={`${base} ${PAY_CLS[s] || PAY_CLS.pending}`}>{s}</span>;
